import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-static-text',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './static-text.component.html',
  styleUrl: './static-text.component.scss',
})
export class StaticTextComponent {
  conceptCardImage = '/Concept card.svg';
}



